import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricImprBing extends MetricBase {
    constructor() {
        super({
            field: "metric_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.impr.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.impr.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.impr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricImprBing;
